import create from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { updateAnchorWithChange, checkIframeChildren } from '../middleware';
export var createStore = function createStore() {
  return create(subscribeWithSelector(updateAnchorWithChange(checkIframeChildren(function () {
    return {};
  }))));
};